/* Mobile category rows expand; their collection links live inside the panel. */
(function () {
  var mobile = window.matchMedia('(max-width: 991px)');
  var nextId = 0;

  function initializeImageMenu(panel) {
    if (panel.classList.contains('image-menu-panel')) return;
    var columns = Array.from(panel.querySelectorAll(':scope > .tt_sub_menu'));
    var tiles = columns.filter(function (column) {
      return column.querySelector('a.menu-banner img') && column.querySelector('.sub_mn_title');
    });
    // Mixed menus retain their existing text groups and mobile image settings.
    if (!tiles.length || columns.some(function (column) {
      return tiles.indexOf(column) === -1 && (column.textContent.trim() || column.querySelector('img, a'));
    }) || panel.querySelector('.product, .list_products_menu')) return;

    panel.classList.add('image-menu-panel');
    var gallery = document.createElement('div');
    gallery.className = 'image-menu-gallery';
    tiles.forEach(function (tile) {
      var heading = tile.querySelector('.sub_mn_title');
      var card = tile.querySelector('a.menu-banner');
      var label = document.createElement('span');
      label.className = 'image-menu-label';
      label.textContent = heading.textContent.trim();
      var image = card.querySelector('img');
      image.alt = '';
      var picture = document.createElement('span');
      picture.className = 'image-menu-picture';
      picture.appendChild(image);
      card.appendChild(label);
      card.appendChild(picture);
      heading.remove();
      gallery.appendChild(tile);
    });
    panel.appendChild(gallery);
  }

  function initialize() {
    document.querySelectorAll('.header_1').forEach(function (header) {
      var logo = header.querySelector('.header_logo_wrap');
      var search = header.querySelector('.site-header__search');
      if (logo && search) {
        if (!search.mobileHome) {
          search.mobileHome = document.createComment('Search desktop position');
          search.before(search.mobileHome);
        }
        logo.parentElement.classList.toggle('mobile-header-layout', mobile.matches);
        if (mobile.matches) logo.before(search);
        else search.mobileHome.after(search);
      }

      header.querySelectorAll('.tt_menu_item').forEach(function (item) {
        var link = item.querySelector(':scope > a');
        if (!link) return;
        var panel = item.querySelector(':scope > .tt_sub_menu_wrap');
        if (!panel) {
          panel = document.createElement('div');
          panel.className = 'tt_sub_menu_wrap mobile-created-panel';
          item.appendChild(panel);
        }
        if (!panel.id) panel.id = 'mobile-collection-panel-' + (++nextId);
        initializeImageMenu(panel);
        var trigger = item.querySelector(':scope > .mobile-nav__sublist-trigger');
        if (!trigger) {
          trigger = document.createElement('span');
          trigger.className = 'mobile-nav__sublist-trigger mobile-created-trigger';
          trigger.innerHTML = '<span class="mobile-nav__sublist-expand"><i class="mdi mdi-chevron-down" aria-hidden="true"></i></span><span class="mobile-nav__sublist-contract"><i class="mdi mdi-chevron-up" aria-hidden="true"></i></span>';
          item.insertBefore(trigger, panel);
        }
        if (!panel.querySelector(':scope > .mobile-collection-link') && link.getAttribute('href') && link.getAttribute('href') !== '#') {
          var all = document.createElement('a');
          all.className = 'mobile-collection-link';
          all.href = link.href;
          var title = link.querySelector('.tt_menu_item_heading_title') || link;
          all.textContent = header.dataset.mobileViewAll + ' · ' + title.textContent.trim();
          panel.prepend(all);
        }
        [link, trigger].forEach(function (control) {
          if (mobile.matches) {
            control.setAttribute('role', 'button');
            control.setAttribute('aria-controls', panel.id);
            control.setAttribute('aria-expanded', item.classList.contains('mobile-category-open') ? 'true' : 'false');
            if (control === trigger) {
              control.tabIndex = 0;
              control.setAttribute('aria-label', link.textContent.trim());
            }
          } else {
            ['role', 'aria-controls', 'aria-expanded', 'tabindex'].forEach(function (attribute) { control.removeAttribute(attribute); });
          }
        });
        if (!mobile.matches) item.classList.remove('mobile-category-open', 'open');
      });
    });
  }

  function controlFor(event) {
    if (!mobile.matches) return null;
    var control = event.target.closest('.header_1 .tt_menu_item > a, .header_1 .tt_menu_item > .mobile-nav__sublist-trigger');
    return control;
  }

  function toggle(control) {
    var item = control.parentElement;
    var opening = !item.classList.contains('mobile-category-open');
    item.closest('.header_1').querySelectorAll('.tt_menu_item').forEach(function (other) {
      var open = other === item && opening;
      other.classList.toggle('mobile-category-open', open);
      other.classList.toggle('open', open);
      other.querySelectorAll(':scope > [aria-expanded]').forEach(function (button) {
        button.setAttribute('aria-expanded', String(open));
      });
    });
  }

  // Capture before the legacy accordion and inline handlers, so a row toggles once.
  document.addEventListener('click', function (event) {
    var control = controlFor(event);
    if (!control) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    toggle(control);
  }, true);
  document.addEventListener('keydown', function (event) {
    var control = controlFor(event);
    if (!control || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    toggle(control);
  }, true);
  mobile.addEventListener('change', initialize);
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
